import axios from "axios";

export const retrieveReport = async (reportId) => {
    try {
        const {data} = await axios.post("/api/powerBIAuth/authenticate", {reportId});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const generateTrainingReport = async (username) => {
    try {
        const {data} = await axios.post("/api/reporting/generateTrainingReport", {username});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
